/**
 * @note Public API Surface of angular-adapter
 */

import {
  flatfileImporter,
  IFlatfileImporter,
  IUnsafeGenerateTokenOptions,
} from '@flatfile/sdk';

export * from './lib/flatfile-adapter.module';
export * from './lib/flatfile-button.component';
export * from './lib/interfaces';

export { flatfileImporter, IFlatfileImporter, IUnsafeGenerateTokenOptions };
